import { User } from 'hooks/use-user'

import { CARDS, Cards } from './consts'

type PlanCode = {
  lifetime: {
    applied: boolean
    code: string
  }
  monthly?: {
    applied: boolean
    code: string
  }
  yearly?: {
    applied: boolean
    code: string
  }
}

type Price = {
  price: number
  value: string
  currency: string
}

type Tier = {
  planCode: PlanCode
  monthly: string
  yearly: string
  lifetime: string
  monthlyPrice?: Price
  yearlyPrice?: Price
  lifetimePrice?: Price
  yearlyPerYear?: string
  yearlyOriginPerMonth?: string
}

type TierPrices = {
  tier0: Tier
  tier1: Tier
  tier2: Tier
  tier3: Tier
  restart: {
    planCode: PlanCode
    monthly: string
  }
  [key: string]: Tier | { planCode: PlanCode; monthly: string }
}

type PriceKey = 'monthlyPrice' | 'lifetimePrice'

export const combineData = (data: TierPrices): Cards => {
  return Object.keys(CARDS).reduce((acc, key) => {
    const { items, ...cardData } = CARDS[key as keyof typeof CARDS]

    acc[key as keyof Cards] = {
      ...cardData,
      items: items.map((item) => {
        const itemTier = item.tier as 'tier1' | 'tier2' | 'tier3'
        const tier = data[itemTier]
        const priceKey = `${key}Price` as PriceKey
        const price = tier?.[priceKey] || { value: '', currency: '' }

        return { ...item, price }
      }),
    }

    return acc
  }, {} as Cards)
}

type Tiers = 'tier1' | 'tier2' | 'tier3'

interface GetButtonTextProps {
  subscription: User['subscription']
  tier: string
  interval: string
  defaultText: string
  isSmallResolution?: boolean
}

const TIER_WEIGHT = {
  tier1: 10,
  tier2: 20,
  tier3: 30,
}

export const getButtonText = ({
  subscription,
  tier,
  interval,
  defaultText,
  isSmallResolution = false,
}: GetButtonTextProps) => {
  if (subscription?.tier && subscription?.planInterval) {
    if (subscription.tier === tier && subscription.planInterval === interval)
      return 'current_plan'
    if (
      TIER_WEIGHT?.[tier as Tiers] > TIER_WEIGHT?.[subscription.tier as Tiers]
    )
      return 'upgrade'
    return isSmallResolution ? 'onboarding_questionnaire_select' : 'select_plan'
  }
  return defaultText
}
